import { Col, InputNumber, Row, Slider } from "antd"
import { t } from "i18next"
import { Number } from ".."

const PriceSlider = props => {
  const { range, steps, setField, value = [0, 0], disable, name = "budget", minFixedAtZero = false } = props

  const minVal = minFixedAtZero ? 0 : (range?.[0] ?? 0)
  const maxVal = range?.[1] ?? 0
  const rawValue = Array.isArray(value) && value.length >= 2 ? value : [minVal, maxVal]
  const safeValue = minFixedAtZero ? [0, Math.max(0, rawValue[1] ?? maxVal)] : rawValue

  const onChange = newValue => {
    setField(name, newValue)
  }

  const onMaxOnlyChange = max => {
    onChange([0, max ?? 0])
  }

  return (
    <Col>
      <Row gutter={16} align="middle" style={{ marginBottom: 8 }}>
        <Col>
          <InputNumber
            min={minVal}
            max={maxVal}
            disabled={disable || minFixedAtZero}
            style={{ width: 130 }}
            value={safeValue[0]}
            onChange={e => (minFixedAtZero ? null : onChange([e ?? minVal, safeValue[1]]))}
          />
        </Col>
        <Col style={{ padding: "0 8px" }}>{t("To")}</Col>
        <Col>
          <InputNumber
            min={minVal}
            max={maxVal}
            disabled={disable}
            style={{ width: 130 }}
            value={safeValue[1]}
            onChange={e => (minFixedAtZero ? onMaxOnlyChange(e ?? 0) : onChange([safeValue[0], e ?? maxVal]))}
          />
        </Col>
      </Row>
      <Col span={24} style={{ maxWidth: 400 }}>
        {minFixedAtZero ? (
          <Slider
            min={0}
            max={maxVal}
            step={steps}
            value={safeValue[1]}
            onChange={onMaxOnlyChange}
            disabled={disable}
            tooltip={{ formatter: val => <Number isStringOnly value={val} /> }}
          />
        ) : (
          <Slider
            range
            min={minVal}
            max={maxVal}
            step={steps}
            value={safeValue}
            onChange={onChange}
            disabled={disable}
            tooltip={{ formatter: val => <Number isStringOnly value={val} /> }}
          />
        )}
      </Col>
    </Col>
  )
}

export default PriceSlider
